<template>
    <!-- Container principal -->
    <v-container fluid class="pa-4">
      <!-- Card de administração -->
      <v-card class="admin-card" elevation="2">
        <!-- Tabs de navegação -->
        <v-tabs
          v-model="tab"
          centered
          outlined
          background-color="primary"
          white
          show-arrows
          height="64"
        >
          <v-tab  dark v-for="(item, i) in tabs" :key="i" :href="`#tab-${i}`">
            <v-icon left>{{ item.icon }}</v-icon>
            {{ item.title }}
          </v-tab>
        </v-tabs>

        <!-- Conteúdo das tabs -->
        <v-tabs-items outlined v-model="tab" class="tab-content">
          <!-- Tab Usuários -->
          <v-tab-item value="tab-0">
            <v-card flat class="pa-4">
              <v-card-title class="d-flex align-center">
                <span class="headline">Lista de Usuários</span>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="searchAtivo"
                  append-icon="mdi-magnify"
                  label="Buscar usuário"
                  single-line
                  hide-details
                  color="primary"
                  class="search-field"
                ></v-text-field>
              </v-card-title>

              <v-data-table
                :headers="headers"
                :items="listaUsuarios"
                :search="searchAtivo"
                :loading="loading"
                loading-text="Carregando usuários..."
                no-data-text="Nenhum usuário encontrado"
                class="elevation-1 user-table"
              >
                <template v-slot:item.status="{ item }">
                  <v-chip
                    small
                    :color="item.status === 'ativo' ? 'green' : 'red'"
                    dark
                  >
                    {{ item.status }}
                  </v-chip>
                </template>

                <template v-slot:item.actions="{ item }">
                  <div class="actions-container">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          small
                          color="primary"
                          v-on="on"
                          @click="goToProfile(item)"
                        >
                          <v-icon>mdi-account</v-icon>
                        </v-btn>
                      </template>
                      <span>Ver perfil</span>
                    </v-tooltip>

                    <vincularVoucher :usuario="item" />
                  </div>
                </template>
              </v-data-table>

              <v-btn
                fab
                dark
                color="primary"
                fixed
                bottom
                right
                class="add-button"
                @click="goToUserRegistration"
              >
                <v-icon dark>mdi-plus</v-icon>
              </v-btn>
            </v-card>
          </v-tab-item>

          <!-- Tab Vouchers -->
          <v-tab-item value="tab-1">
            <v-card flat class="pa-4">
              <Voucher />
            </v-card>
          </v-tab-item>

          <!-- Tab Pacotes Laboratoriais -->
          <v-tab-item value="tab-2">
            <v-card flat class="pa-4">
              <PacoteExames :sadt="true" />
            </v-card>
          </v-tab-item>

          <!-- Tab Pacotes Ocupacionais -->
          <v-tab-item value="tab-3">
            <v-card flat class="pa-4">
              <PacoteExames :sadt="false" />
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>

      <!-- Card de perfil (quando aberto) -->
      <v-card v-if="isPerfil" class="profile-card mt-4" elevation="2">
        <PerfilUsuario :id="perfilSelecionado._id" @back="isPerfil = false" />
      </v-card>
    </v-container>
</template>

<script>
import PerfilUsuario from './PerfilUsuario.vue'
import usuarioService from '../../../services/usuario.service'
import vincularVoucher from './VincularVoucher.vue'
import PacoteExames from './PacoteExames.vue'
import Voucher from './Voucher.vue'

export default {
  components: {
    PacoteExames,
    Voucher,
    vincularVoucher,
    PerfilUsuario
  },
  data() {
    return {
      tab: null,
      loading: false,
      searchAtivo: '',
      isPerfil: false,
      perfilSelecionado: null,
      listaUsuarios: [],
      tabs: [
        { title: 'Usuários', icon: 'mdi-account' },
        { title: 'Vouchers', icon: 'mdi-tag' },
        { title: 'Pacotes Laboratoriais', icon: 'mdi-test-tube' },
        { title: 'Pacotes Ocupacionais', icon: 'mdi-briefcase' }
      ],
      headers: [
        {
          text: 'Nome do Usuário',
          align: 'start',
          sortable: true,
          value: 'nomeCompleto',
          width: '60%'
        },
        {
          text: 'Status',
          align: 'center',
          value: 'status',
          sortable: true,
          width: '20%'
        },
        {
          text: 'Ações',
          align: 'center',
          value: 'actions',
          sortable: false,
          width: '20%'
        }
      ]
    }
  },
  created() {
    this.listarUsuarios()
  },
  methods: {
    async listarUsuarios() {
      this.loading = true
      try {
        const response = await usuarioService.listarUsuarios()
        if (response.status === 200) {
          this.listaUsuarios = response.data
        }
      } catch (error) {
        console.error('Erro ao carregar usuários:', error)
      } finally {
        this.loading = false
      }
    },
    goToProfile(item) {
      this.perfilSelecionado = item
      this.isPerfil = true
    },
    goToUserRegistration() {
      this.$router.push({ 
        name: 'cadastrarUsuario', 
        params: { cadastro: true, _id: null } 
      })
    }
  }
}
</script>

<style scoped>
.admin-dashboard {
  background-color: #f5f7fa;
}

.admin-card {
  border-radius: 8px;
  overflow: hidden;
}

.tab-content {
  background-color: white;
}

.user-table {
  margin-top: 16px;
}

.user-table >>> thead tr th {
  font-weight: 600;
  font-size: 14px;
  color: #424242 !important;
}

.user-table >>> tbody tr td {
  font-size: 14px;
}

.actions-container {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.search-field {
  max-width: 300px;
}

.add-button {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 10;
}

.profile-card {
  border-radius: 8px;
}

/* Responsividade */
@media (max-width: 960px) {
  .admin-card {
    margin: 0;
  }
  
  .search-field {
    max-width: 100%;
    margin-top: 12px;
  }
}

@media (max-width: 600px) {
  .admin-dashboard {
    padding: 8px;
  }
  
  .add-button {
    bottom: 16px;
    right: 16px;
    width: 48px;
    height: 48px;
  }
}
</style>